import React from 'react';

const UserRankingChart = ({ data }) => {
  const mockData = [
    { name: 'Juan Pérez', requests: 45, amount: 2500000 },
    { name: 'María García', requests: 38, amount: 2100000 },
    { name: 'Carlos López', requests: 32, amount: 1800000 },
    { name: 'Ana Rodríguez', requests: 28, amount: 1500000 },
    { name: 'Luis Martínez', requests: 24, amount: 1200000 }
  ];

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value);
  };

  const userData = data || mockData;

  return (
    <div className="w-full h-full">
      <div className="chart-header">
        <h3 className="chart-title">Ranking de Usuarios</h3>
        <p className="chart-subtitle">Usuarios por cantidad de IPRs creados</p>
      </div>

      <div className="chart-content">
        <div className="space-y-3">
          {userData.map((user, index) => (
            <div
              key={index}
              className="flex items-center justify-between p-3 bg-gray-50 rounded"
            >
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center text-white font-bold text-sm">
                  {index + 1}
                </div>
                <div>
                  <p className="font-medium text-sm">{user.name}</p>
                  <p className="text-xs text-gray-500">
                    {user.requests} requisiciones
                  </p>
                </div>
              </div>
              <div className="text-right">
                <p className="text-sm font-medium">{user.amount} IPRs</p>
                <div className="w-16 bg-gray-200 rounded-full h-1 mt-1">
                  <div
                    className="bg-orange-500 h-1 rounded-full"
                    style={{
                      width: `${
                        (user.requests /
                          Math.max(...userData.map((u) => u.requests))) *
                        100
                      }%`,
                    }}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="chart-footer">
        <div className="chart-insight">Top 5 usuarios por actividad</div>
        <div className="chart-metric">
          Total: {userData.reduce((sum, user) => sum + user.requests, 0)}{" "}
          requisiciones
        </div>
      </div>
    </div>
  );
};

export default UserRankingChart; 